import { IMercadoRelevante } from '../../core/interfaces/relevant-markets.interface';

export class GetAllRelevantMarketsAction {
  static readonly type = '[RelevantMarkets] Get All';
  constructor() {}
}

export class AddRelevantMarketAction {
  static readonly type = '[RelevantMarket] Add';
  constructor(public payload: IMercadoRelevante) {}
}

export class UpdatedRelevantMarketAction {
  static readonly type = '[RelevantMarket] Updated';
  constructor(public payload: IMercadoRelevante) {}
}

export class DeleteRelevantMarketAction {
  static readonly type = '[RelevantMarket] Delete';
  constructor(public payload: IMercadoRelevante) {}
}
